<template>
  <header class="subHeader" :class="{'backgroundColor': isBackground}">
    <div class="noMargin" :class="{'paddingTop27px': !fixElement}">
      <div class="filter-wrapper row">
        <div class="date-out-wrapper col-md-4" v-if="eventStatus == 'upcoming'">
          <div v-if="!fixElement" class="dateOut"><span class="label">DATES OUT</span></div>
          <div :class="{'marginTop10px': fixElement}">
            <vue-slider ref="slider" v-bind="datesOut" v-model="datesOut.value"
                        @click.native="getValue('slider')"></vue-slider>
          </div>
        </div>
        <div class="input-search-wrapper col-md-4" >
          <b-input-group class="ap-input-wrapper">
            <b-form-input class="placeholder-italic input body-text" :class="{'marginTop6px': fixElement}" v-model="textSearch"
                          type="text"
                          placeholder="Search by event info" :formatter="format"
                          @change="getValue('slider')"></b-form-input>
            <div class="search-icon"></div>
          </b-input-group>
        </div>
        <div class="col-md-4 filter-btn-wrapper">
          <div class="icon-wrapper marginTop6px" :class="{'active-wrapper': isShowAction, 'marginTop11px': fixElement}"
               @click="isShowAction = true" @mouseleave="isShowAction = false">
            <Icon class="icon-filter" :class="{'active': isShowAction}" :name="'filter'"></Icon>
            <ul class="action-panel" v-if="isShowAction">
              <div class="title">Display</div>
              <li v-for="item in listEventStatus" :key="item.text">
                <div class="input-checkbox" :class="{'checkbox-active': item.isCheck}">{{ item.text }}
                  <input :checked="listChecked.indexOf(item.key) >= 0" type="checkbox" @click="selectStatus(item)"
                         title=""/>
                  <span class="checkmark"></span>
                </div>
              </li>
            </ul>
          </div>
          <div class="sorted-text">sort by <span style="font-weight: 600;">{{selectedSortText}}</span></div>
        </div>
        <div class="scroll-up-wrapper">
          <div class="upIcon" :class="{'display-none-something': !fixElement, 'scrollIcon': fixElement}">
            <ScrollTop></ScrollTop>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
  // import consts from '../../_consts';
  import Icon from 'vue-awesome/components/Icon';
  import {mapActions, mapMutations, mapGetters} from 'vuex';
  import VueSlider from 'vue-slider-component';
  import ScrollTop from '../utils/ScrollTop';
  import _ from 'lodash';

  export default {
    name: 'subHeaderManageReports',
    methods: {
      getValue (name) {
      },
      selectStatus (item) {
        this.listChecked = [item.key];
        this.selectedSortText = item.text;
        this.$emit('CHANGE_FILTER_OPTION', this.listChecked);
      },
      ...mapActions({
      }),
      ...mapMutations({
        searchApprovedEvent: 'MUTATION_SEARCH_APPROVED_EVENT',
        mutationSaveManageEventReports: 'MUTATION_SAVE_MANAGE_EVENT_REPORTS',
        mutationGetSliderValueReports: 'MUTATION_SAVE_SLIDER_VALUE_REPORTS'
      })
    },
    computed: {
      ...mapGetters({
        getterGetSliderValueReports: 'GETTER_GET_SLIDER_VALUE_REPORTS'
      })
    },
    watch: {
      textSearch: _.debounce(function () {
        let keyword = this.textSearch.trim().toLowerCase();
        if (keyword.length >= 2 || keyword.length === 0) {
          this.$emit('TEXT_SEARCH_CHANGE', keyword);
        }
      }, 700),
      pagingObj: {
        handler: function () {
          this.getValue('slider');
        },
        deep: true
      },
      eventStatus: {
        handler: function () {
          this.getValue('slider');
        },
        deep: true
      },
      'datesOut.value': _.debounce(function () {
        this.$emit('SLIDER_CHANGE_VALUE', this.datesOut.value);
      }, 300)
    },
    components: {
      Icon,
      VueSlider,
      ScrollTop
    },
    props: {
      fixElement: {
        type: Boolean,
        default: false
      },
      pagingObj: {
        type: Object,
        default: {}
      },
      eventStatus: {
        type: String,
        default: ''
      },
      sliderValue: {
        type: Array,
        required: true
      }
    },
    mounted () {
    },
    created () {
      this.datesOut.value[0] = this.getterGetSliderValueReports.noBeginDates || '0';
      this.datesOut.value[1] = this.getterGetSliderValueReports.noEndDates || '60+';
    },
    data () {
      return {
        listEventStatus: [
          {
            text: 'Date (closest to farthest)',
            count: 200,
            isCheck: false,
            key: 'dateTime'
          },
          {
            text: 'Event Name (alphabetical)',
            count: 0,
            isCheck: false,
            key: 'eventName'
          },
          {
            text: 'Participation (most to least)',
            count: 100,
            isCheck: false,
            key: 'projPart'
          },
          {
            text: 'City (alphabetical)',
            count: 100,
            isCheck: false,
            key: 'city'
          },
          {
            text: 'State (alphabetical)',
            count: 100,
            isCheck: false,
            key: 'state'
          }
        ],
        isShowAction: false,
        datesOut: {
          value: ['0', '0'],
          width: '182px',
          tooltip: false,
          disabled: false,
          piecewise: true,
          piecewiseLabel: true,
          dotSize: 8,
          interval: 7,
          formatter: '{value}',
          overlapFormatter: '{value1} ~ {value2}',
          data: [
            '0',
            '7',
            '14',
            '30',
            '60',
            '60+'
          ],
          piecewiseStyle: {
            backgroundColor: 'transparent',
            visibility: 'visible',
            width: '15px',
            height: '15px'
          },
          piecewiseActiveStyle: {
            backgroundColor: '#00A4D6'
          },
          processStyle: {
            backgroundColor: '#00A4D6'
          }
        },
        textSearch: '',
        listChecked: ['dateTime'],
        selectedSortText: 'Date (closest to farthest)'
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../styles/variables.less';

  .paddingLeft9px {
    padding-left: 9px;
  }

  .backgroundColor {
    background-color: #f5f5f5 !important;
  }

  .subHeader {
    /*height: 96px;*/
    background-color: @grey-5;
    z-index: 990;

    .filter-wrapper{
      display: flex;
      justify-content: flex-start;
      position: relative;

      .scroll-up-wrapper{
        position: absolute;
        right: 20px;
        width: 20px;
        height: 20px;
      }

      .date-out-wrapper{
        max-width: 230px;
      }

      .input-search-wrapper{
      }

      .filter-btn-wrapper{
      }
    }

    .title {
      font-size: 12px;
      letter-spacing: 0.1px;
      // margin-top: 15px;
      height: 20px;
      text-transform: uppercase;
    }
    .marginTop10px {
      margin-top: 10px;
    }
    .dateOut {
      position: relative;
      top: -15px;
    }
    .paddingLeft19px {
      padding-left: 19px !important;
    }
    .active-wrapper {
      border-color: @dark-blue-2 !important;
      background-color: @dark-blue-2;
    }
    .icon-wrapper {
      border: solid 1px @light-blue;
      border-radius: 3px;
      width: 32px;
      height: 32px;
      position: relative;
      text-align: center;
      float: left;
      margin-right: 16px;
      &:hover {
        cursor: pointer;
      }
      &.marginTop11px {
        margin-top: 11px;
      }
      .icon-filter {
        margin: 1.5px 1.5px;
        width: 27px;
        height: 27px;
        color: @light-blue;
        background-color: @light-blue;
        -webkit-mask: url('../../../static/img/sort_black.svg') no-repeat center;
        mask: url('../../../static/img/sort_black.svg') no-repeat center;
        background: url('../../../static/img/sort_blue.svg');
      }
      .active {
        color: @white;
        background-color: @white;
      }
      ul.action-panel {
        list-style: none;
        font-size: 12px;
        line-height: 26px;
        text-align: left;
        padding: 15px;
        margin-bottom: 0;
        border-radius: 3px;
        background-color: #FFFFFF;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
        position: absolute;
        top: 32px;
        left: 0;
        width: 215px;
        z-index: 9999;
        .title {
          font-size: 12px;
          letter-spacing: 0.1px;
          line-height: 16px;
          color: @black-1;
        }
        li {
          // padding-left: 10px;
          // border-bottom: solid 1px #E6E6E6;
          &:last-child {
            border-bottom: none;
          }
          .checkbox-active {
            color: @light-blue !important;
            font-weight: bold;
          }
          .input-checkbox {
            display: block;
            position: relative;
            padding-left: 20px;
            margin-bottom: 0;
            // cursor: pointer;
            color: @black-2;
            // font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            input {
              position: absolute;
              opacity: 0;
              cursor: pointer;
              left: 0;
              bottom: 6px;
              width: 16px;
              height: 16px;
              z-index: 10;
            }
            .checkmark {
              position: absolute;
              top: 4px;
              left: 0;
              height: 16px;
              width: 16px;
              background-color: #FFFFFF;
              border: solid 1px @grey-3;
              z-index: 1;
              &::after {
                left: 6px;
                top: 2px;
                width: 5px;
                height: 10px;
                border: solid white;
                border-width: 0 2px 2px 0;
                -webkit-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                transform: rotate(45deg);
                content: "";
                position: absolute;
                display: none;
              }
            }
          }
          /* On mouse-over, add a grey background color */
          .input-checkbox:hover input ~ .checkmark {
            // background-color: @white;
            // cursor: pointer;
          }

          /* When the checkbox is checked, add a blue background */
          .input-checkbox input:checked ~ .checkmark {
            background-color: @light-blue;
            color: @light-blue;
            border: none;
          }
          /* Show the checkmark when checked */
          .input-checkbox input:checked ~ .checkmark:after {
            display: block;
          }
          .input-checkbox ~ .checkmark:after {
            color: @light-blue;
          }
        }
      }
    }
    .group-button-sub-header {
      float: right;
      top: 120px;
      margin: 65px 30px 0 0;
    }

    .placeholder-italic {
      font-family: 'Open Sans', sans-serif;
      color: @black;
      border-radius: 4px;
      z-index: unset;
      background-color: @white;
      padding: 12px 16px;
      font-size: 16px;
      line-height: 20px;
      height: 42px;
    }
    .search-icon {
      position: absolute;
      right: 8px;
      bottom: 8px;
      z-index: 999;
      color: @light-blue;
      width: 20px;
      height: 25px;
      &:hover {
        cursor: pointer;
        color: @light-blue;
      }
    }

    .content-header {
      width: 250px;
    }

    .float-left {
      float: left;
    }

    .float-right {
      float: right;
    }

    .label {
      height: 16px;
      width: 77.8px;
      color: #444444;
      font-family: "Open Sans", serif;
      font-size: 12px;
      letter-spacing: 0.1px;
      line-height: 16px;
      // padding-left: 10px;
    }
    .search-icon {
      height: 25px;
      width: 25px;
      background-color: #3caae9;
      -webkit-mask: url('../../../static/img/search.svg') no-repeat center;
      mask: url('../../../static/img/search.svg') no-repeat center;
      background: url('../../../static/img/search-blue.svg');
    }
    .upIcon {
      float: right;
    }
    .scrollIcon {
      position: absolute;
      top: 0;
      right: 0;
    }
    .display-none-something {
      display: none;
    }
    .marginTop6px {
      margin-top: 6px;
    }
  }

  .sorted-text {
    height: 42px;
    color: #1D1D1D;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    line-height: 42px;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// SubHeaderManageReports.vue?475d8c38